import type { JSX } from 'react'

export const BundleCover9 = (): JSX.Element => (
  <svg
    width='100%'
    height='100%'
    viewBox='0 0 1920 1080'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    preserveAspectRatio='none'
  >
    <rect width='1920' height='1080' fill='#161616' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M572.019 0C572.609 22.5527 573.843 45.4512 575.819 68.5039C394.664 148.08 199.701 275.828 0 465.732V692.828C214.263 464.248 419.322 318.711 603.479 231.611C615.64 277.402 631.768 321.928 652.672 363.57C699.181 456.221 771.077 537.744 877.587 583.152C983.588 628.342 1113.86 633.492 1269.5 592.84C1460.68 542.908 1587.71 432.812 1576.35 283.605C1566.39 152.91 1450.9 50.873 1304.33 0H768.017C756.238 3.21094 744.377 6.62891 732.438 10.2578C732.3 6.83594 732.179 3.41602 732.075 0H572.019ZM795.667 291.789C777.253 255.107 763.395 214.326 753.362 171.531C951.973 106.41 1118.15 110.395 1233.71 145.271C1365.77 185.123 1413.75 255.596 1416.81 295.762C1419 324.584 1397.26 394.105 1229.07 438.033C1097.22 472.471 1004.99 463.533 940.334 435.969C876.185 408.621 829.267 358.723 795.667 291.789Z'
      fill='url(#paint0_linear_628_276)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M993.897 0C956.821 185.115 933.227 396.154 946.829 591.92C950.459 644.16 956.785 696.068 966.469 746.625C832.263 819.297 686.749 927.717 531.395 1080H767.993C854.679 1006.07 935.72 948.787 1010.74 905.234C1025.87 944.797 1043.96 982.574 1065.42 1017.93C1078.62 1039.67 1093.04 1060.4 1108.74 1080H1359.86C1291.52 1048 1240.55 998.1 1202.2 934.912C1183.82 904.631 1168.21 871.025 1155.19 834.568C1203.95 815.379 1249.35 802.48 1291.24 794.738C1454.52 764.555 1565.8 811.811 1627.71 872.975C1693.35 937.816 1702.62 1013.18 1682.64 1055.84C1679.09 1063.41 1673.61 1071.83 1665.5 1080H1843.4C1872.63 969.57 1828.02 845.951 1740.16 759.15C1636.76 657.002 1470.7 598.852 1262.15 637.402C1215.75 645.98 1167.33 659.299 1117 677.885C1112.26 646.645 1108.77 614.232 1106.44 580.83C1093.26 391.156 1118.71 181.533 1157.26 0H993.897Z'
      fill='url(#paint1_linear_628_276)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_628_276'
        x1='788.526'
        y1='0'
        x2='788.526'
        y2='692.828'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#0B0C24' />
        <stop offset='1' stopColor='#380E51' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_628_276'
        x1='1191.86'
        y1='0'
        x2='1191.86'
        y2='1080'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#0A0B31' />
        <stop offset='1' stopColor='#500E78' />
      </linearGradient>
    </defs>
  </svg>
)
